(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ClickSignVatController', clickSignVatController);

  clickSignVatController.$inject = ['$rootScope', 'NotificationService', 'DigitalSignService', 'Upload'];
 	function clickSignVatController ($rootScope, NotificationService, DigitalSignService, Upload) {
    var clickSignVatVm = this;

    clickSignVatVm.digitalSignature = {};
    clickSignVatVm.digitalSignature.documentPath = [];
    clickSignVatVm.digital_signature_docs = [];
    clickSignVatVm.addDigitalSignatureProposalByCpf = addDigitalSignatureProposalByCpf;
    clickSignVatVm.saveDigitalSignatureVat = saveDigitalSignatureVat;
    clickSignVatVm.saveDigitalSignatureProposalByCpf = saveDigitalSignatureProposalByCpf;
    clickSignVatVm.signDigitalSignatureByCpf = signDigitalSignatureByCpf;
    clickSignVatVm.uploadCCBByCpf = uploadCCBByCpf;
    clickSignVatVm.toLowerCaseWithoutAccents = toLowerCaseWithoutAccents;

    function toLowerCaseWithoutAccents (string = '') {
      var strAccents = string.split('');
      var strAccentsOut = new Array();
      var strAccentsLen = strAccents.length;
      var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
      var accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
      for (var y = 0; y < strAccentsLen; y++) {
        if (accents.indexOf(strAccents[y]) != -1) {
          strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
        } else { strAccentsOut[y] = strAccents[y]; }
      }
      strAccentsOut = strAccentsOut.join('');

      return strAccentsOut.toLowerCase();
    }

    function addDigitalSignatureProposalByCpf (key) {
      if (!$rootScope.vm.proposals[key]) {
        $rootScope.vm.proposals = [];
        $rootScope.vm.proposals[key] = [];
      }

      var totalProposals = $rootScope.vm.proposals[key].length;
      $rootScope.vm.proposals[key][totalProposals] = null;
    }

    function saveDigitalSignatureVat (type, doc, index) {
      var value = $rootScope.vm.selectedUser[$rootScope.vm.sector_id].digital_signature_vat[type];

      DigitalSignService.updateDocumentsInfoByCpf({
        'clicksign_flow': 'VAT',
        'cpf': type,
        'document': 'doc',
        'value': value,
        'contact': {
          'sector_id': $rootScope.vm.sector_id,
          'contact_id': $rootScope.vm.selectedUser[$rootScope.vm.sector_id].id,
          'company_id': $rootScope.vm.operator.company_id
        }
      })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Documentos salvos com sucesso.');
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Error ao atualizar ' + type);
        });
    }

    function saveDigitalSignatureProposalByCpf (index, proposal_number, cpf) {
      if (!proposal_number) {
        return;
      }

      if (proposal_number.length != 11) {
        NotificationService.errorHandler(null, $rootScope.labels.chatInvalidContractVat);
        return;
      }

      DigitalSignService.updateDocumentsInfoByCpf({
        'clicksign_flow': 'VAT',
        'cpf': cpf,
        'document': 'proposals',
        'value': {
          'number': proposal_number
        },
        'index': index,
        'contact': {
          'sector_id': $rootScope.vm.sector_id,
          'contact_id': $rootScope.vm.selectedUser[$rootScope.vm.sector_id].id,
          'company_id': $rootScope.vm.operator.company_id
        }
      })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, 'Documentos salvos com sucesso.');
          $rootScope.vm.checkClicksignVatProposals();
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Error ao atualizar ' + cpf);
        });
    }

       	function uploadCCBByCpf (file, cpf, index, proposal_number) {
      if ((!proposal_number) || (proposal_number.length != 11)) {
        NotificationService.errorHandler(null, $rootScope.labels.chatInsertContract);
        return;
      }

      if (file) {
        Upload.upload({
          url: apiUrl + '/upload-ccb',
          file: file
        }).then(function (resp) {
          if (resp.data.public_path) {
            if (!clickSignVatVm.digitalSignature.documentPath[cpf]) {
              clickSignVatVm.digitalSignature.documentPath[cpf] = [];
            }
            clickSignVatVm.digitalSignature.documentPath[cpf][index] = resp.data.public_path;
          }
          NotificationService.successHandler(resp, $rootScope.labels.CBBImported);
        }, function (resp) {
          NotificationService.errorHandler(resp, $rootScope.labels.errorImportCBB);
        }, function (evt) {
        });
      }
    }

    function signDigitalSignatureByCpf (contact, cpf, index, proposal_number) {
      var documentPath = '';

      if (clickSignVatVm.digital_signature_docs[cpf] && clickSignVatVm.digital_signature_docs[cpf][index] && vm.digital_signature_docs[cpf][index].hasOwnProperty('ccb')) {
        documentPath = vm.digital_signature_docs[cpf][index];
      } else if (clickSignVatVm.digitalSignature.documentPath[cpf] && clickSignVatVm.digitalSignature.documentPath[cpf][index]) {
        documentPath = clickSignVatVm.digitalSignature.documentPath[cpf][index];
      } else {
        NotificationService.errorHandler({}, 'Necessário o upload do CCB.');
        return;
      }

      if (clickSignVatVm.digital_signature_docs[cpf] && clickSignVatVm.digital_signature_docs[cpf][index] && clickSignVatVm.digital_signature_docs[cpf][index].approved_at) {
        NotificationService.warningHandler(null, 'Proposta já assinada.');
        return;
      }

      clickSignVatVm.signing = [];
      clickSignVatVm.signing[cpf] = [];
      clickSignVatVm.signing[cpf][proposal_number] = true;
      DigitalSignService.approveProposal({
        'proposal_number': proposal_number,
        'proposal_index': index,
        'contact_id': contact.id,
        'phone': contact.digital_signature_vat[cpf].contact_info.mobile_phone,
        'sector_id': $rootScope.vm.sector_id,
        'company_id': $rootScope.vm.operator.company_id,
        'proposal_path': documentPath,
        'contact_email': contact.digital_signature_vat[cpf].contact_info.email,
        'data_nasc': contact.digital_signature_vat[cpf].personal_info.birth_date,
        'full_name': contact.digital_signature_vat[cpf].personal_info.full_name,
        'cpf': cpf,
        'channel_id': contact.data.channel_id,
        'vat': true
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            if (data.urlSentBySMS) {
              $rootScope.vm.sendCustomMessage($rootScope.vm.sector_id, 'Finalizamos a formalização dos documentos, agora será necessário que o(a) cliente acesse o link que será encaminhado por SMS e realizar a assinatura eletrônica da sua proposta, conforme imagem de exemplo:', { 'contact_phone': contact.digital_signature_vat[cpf].contact_info.mobile_phone });
            } else {
              var clicksignUrl = data.clicksignUrl;
              $rootScope.vm.sendCustomMessage($rootScope.vm.sector_id, 'Finalizamos a formalização dos documentos, agora será necessário que o(a) cliente acesse esse link ' + clicksignUrl + ' e realizar a assinatura eletrônica da sua proposta, conforme imagem de exemplo:', { 'contact_phone': contact.digital_signature_vat[cpf].contact_info.mobile_phone });
            }
            $rootScope.vm.file = data.clicksignUrlImage.public_path;
            $rootScope.vm.file_type = data.clicksignUrlImage.type;
            $rootScope.vm.file_name = data.clicksignUrlImage.key;
            $rootScope.vm.file_original_name = data.clicksignUrlImage.key;
            $rootScope.vm.sendAttach();

            NotificationService.successHandler(data, 'Proposta enviada!');
            $rootScope.vm.proposals[cpf][index].signed = 1;
          } else if (data.hasOwnProperty('message')) {
            NotificationService.warningHandler(data, data.message);
          } else {
            NotificationService.errorHandler(data);
          }
          clickSignVatVm.signing[cpf][proposal_number] = false;
        })
        .catch(function (data) {
          clickSignVatVm.signing[cpf][proposal_number] = false;
          NotificationService.errorHandler(data, 'Erro ao enviar proposta para envio! Verifique se os dados estão corretos.');
        });
    }

    clickSignVatVm.sendDocumentsAgain = function (documentKey, cpf, proposal_index) {
      DigitalSignService.sendDocumentsAgain({
        'document_key': documentKey,
        'vat': true,
        'cpf': cpf,
        'proposal_index': proposal_index,
        'sector_id': $rootScope.vm.sector_id,
        'contact_id': $rootScope.vm.selectedUser[$rootScope.vm.sector_id].id,
        'company_id': $rootScope.vm.operator.company_id
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler(data, $rootScope.labels.docSendingAgain);
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorDocSendingAgain);
        });
    }
  }
})();
